import React from "react";
import { Phone, MessageSquare } from "lucide-react";
import { COMPANY } from "@/lib/constants";

export const StickyMobileCTA = () => {
  // Strip non-digits so we can build an sms: href
  const digits = COMPANY.phoneHref.replace(/[^0-9+]/g, "");
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 md:hidden border-t border-slate-900 bg-[#0B1726]/95 backdrop-blur-xl">
      <div className="flex">
        <a
          href={COMPANY.phoneHref}
          data-testid="sticky-call-btn"
          className="flex-1 flex items-center justify-center gap-2 py-4 text-white font-heading uppercase tracking-wider text-sm border-r border-slate-900"
        >
          <Phone className="w-4 h-4 text-[#E6B445]" /> Call
        </a>
        <a
          href={`sms:${digits}`}
          data-testid="sticky-text-btn"
          className="flex-1 flex items-center justify-center gap-2 py-4 text-white font-heading uppercase tracking-wider text-sm border-r border-slate-900"
        >
          <MessageSquare className="w-4 h-4 text-[#E6B445]" /> Text
        </a>
        <a
          href="/quote"
          data-testid="sticky-quote-btn"
          className="flex-1 flex items-center justify-center gap-2 py-4 bg-[#1E88E5] text-white font-heading uppercase tracking-wider text-sm"
        >
          Get Quote
        </a>
      </div>
    </div>
  );
};
